import React from "react";
import PageTitle from "../../Module/pageTitle";
import "../CustomTheme/customTheme.css";
import "./CustomPageLayout.css";

/**
 * CustomPageLayout — the standard page frame:
 * PageTitle header + scrollable body with consistent padding.
 * Replaces the hand-written
 *   <div className="contentBox"><PageTitle .../><div className="formDiv contentScrollbar">…
 *
 *   <CustomPageLayout
 *     title="Cron Management"
 *     subtitle="Run any scheduled job on demand"
 *     actions={<CustomButton icon={<Plus size={14} />}>Add New</CustomButton>}
 *     isGoBack={view === "form"} onBack={closeForm}
 *   >
 *     ...page content...
 *   </CustomPageLayout>
 *
 * Props:
 *  - title        page name (shown upper-case by PageTitle)
 *  - subtitle     grey line under the header (optional)
 *  - actions      buttons shown right of the subtitle (wrap under it on phones)
 *  - headerActions  buttons at the right end of the title bar, e.g. a Filters button
 *                 (see useHeaderFilterButton in CustomAdminTable)
 *  - isGoBack, onBack     shows PageTitle's "Go Back" button
 *  - titleProps   any extra PageTitle props (isEditMode, btnName, isSupportCount, …)
 *  - padded       body padding (default true)
 *  - background   "subtle" (default, light grey) | "plain" (white)
 *  - fill         table pages: the CustomAdminTable shrinks to the space left under the cards, so only
 *                 the table body scrolls, not the whole page (its maxHeight is ignored; min 320px).
 *                 Cards above the table → wrap cards + table in <div className="cpl-fillStack …">
 *  - className, bodyClassName
 */
const CustomPageLayout = ({
  title,
  subtitle,
  actions,
  headerActions,
  isGoBack,
  onBack,
  titleProps,
  padded = true,
  background = "subtle",
  fill = false,
  className,
  bodyClassName,
  children,
}) => (
  <div className={`contentBox cpl-page${className ? ` ${className}` : ""}`}>
    <PageTitle name={title} isGoBack={isGoBack} onClick={onBack} actions={headerActions} {...titleProps} />

    <div
      className={`formDiv contentScrollbar cpl-body cpl-bg-${background}${
        padded ? " cpl-padded" : ""
      }${fill ? " cpl-fill" : ""}${bodyClassName ? ` ${bodyClassName}` : ""}`}
    >
      {(subtitle || actions) && (
        <div className="cpl-toolbar">
          {subtitle && <p className="cpl-subtitle">{subtitle}</p>}
          {actions && <div className="cpl-actions">{actions}</div>}
        </div>
      )}
      {children}
    </div>
  </div>
);

export default CustomPageLayout;
